<template>
  <div class="container" ref="container">
    <div class="input-wrap">
      <p class="input" @click="showStartDialog">
        <span v-if="showStartTime">
          {{ `${startTimeH || "-"} : ${startTimeM || "-"}` }}
        </span>
        <span style="color: #c5c7c7" v-else> 开始时间 </span>
        <i
          @click.stop="cancel"
          style="float: right; line-height: 30px"
          v-if="showStartTime"
          class="el-icon-error ico"
        ></i>
      </p>
      <div
        :class="showDirection === 'top' ? 'dialog top' : 'dialog'"
        v-if="startDialogVisible"
        :style="`top:${this.dialogY}px;left:${this.dialogX}px;width:${dialogWidth}px;`"
      >
        <div class="selector-wrap" v-if="showDirection === 'top'">
          <div class="item" id="start-h">
            <div
              :class="startTimeH === fixedNumber(n - 1) ? 'num active' : 'num'"
              v-for="n in 24"
              :key="n"
              @click="sHselect(n)"
            >
              {{ fixedNumber(n - 1) }}
            </div>
          </div>
          <div class="item" id="start-m">
            <div
              :class="
                startTimeM === fixedNumber((n - 1) * 5) ? 'num active' : 'num'
              "
              v-for="n in 12"
              :key="n"
              @click="sMselect(n)"
            >
              {{ fixedNumber((n - 1) * 5) }}
            </div>
          </div>
        </div>
        <div class="dialog-input-wrap">
          <p class="dialog-input">
            <span v-show="startTimeH && startTimeM">{{
              `${startTimeH} : ${startTimeM}`
            }}</span>
          </p>
        </div>
        <div class="selector-wrap" v-if="showDirection === 'bottom'">
          <div class="item" id="start-h">
            <div
              :class="startTimeH === fixedNumber(n - 1) ? 'num active' : 'num'"
              v-for="n in 24"
              :key="n"
              @click="sHselect(n)"
            >
              {{ fixedNumber(n - 1) }}
            </div>
          </div>
          <div class="item" id="start-m">
            <div
              :class="
                startTimeM === fixedNumber((n - 1) * 5) ? 'num active' : 'num'
              "
              v-for="n in 12"
              :key="n"
              @click="sMselect(n)"
            >
              {{ fixedNumber((n - 1) * 5) }}
            </div>
          </div>
        </div>
      </div>
      <div class="mask" v-if="startDialogVisible" @click="submit"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["originStart"],
  data() {
    return {
      startTimeH: "",
      startTimeM: "",
      startDialogVisible: false,
      showDirection: "bottom",
      showStartTime: true, // 显示开始时间
      dialogX: 0, // dialog改为fixed，XY为浮窗left和top
      dialogY: 0,
      dialogWidth: 0,
    };
  },
  watch: {
    originStart(n, o) {
      this.init(n);
    },
  },
  created() {
    this.init(this.originStart);
  },
  methods: {
    init(o) {
      if (o) {
        const time = o.split(":");
        this.startTimeH = time[0];
        this.startTimeM = time[1];
        this.showStartTime = true;
      } else {
        this.startTimeH = "";
        this.startTimeM = "";
        this.showStartTime = false;
      }
    },
    cancel() {
      this.startTimeH = "";
      this.startTimeM = "";
      this.showStartTime = false;
      this.startDialogVisible = false;
      this.$emit("handleChange", "");
    },
    submit() {
      if (this.startTimeH && this.startTimeM) {
        const Time = this.startTimeH + ":" + this.startTimeM;
        this.$emit("handleChange", Time);
      }
      this.startDialogVisible = false;
    },
    showStartDialog(e) {
      let elementInfo = this.$refs.container.getBoundingClientRect();
      this.dialogWidth = this.$refs.container.offsetWidth;
      const screenH = window.document.body.clientHeight;
      const clickY = e.pageY;
      if (screenH - clickY < 240) {
        this.showDirection = "top";
        this.dialogY = elementInfo.y - 196 + 28;
      } else {
        this.showDirection = "bottom";
        this.dialogY = elementInfo.y;
      }
      this.dialogX = elementInfo.x;
      this.startDialogVisible = true;
      this.$nextTick(() => {
        const h = 28 * (Number(this.startTimeH) || 12);
        const m = (28 * Number(this.startTimeM)) / 5;
        document.getElementById("start-h").scrollTop = h;
        document.getElementById("start-m").scrollTop = m;
      });
    },
    fixedNumber(n) {
      return 10 > n ? "0" + n : String(n);
    },
    sHselect(n) {
      this.startTimeH = this.fixedNumber(n - 1);
    },
    sMselect(n) {
      this.startTimeM = this.fixedNumber((n - 1) * 5);
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  .input-wrap {
    position: relative;
    height: 30px;
    .input {
      .ico {
        display: none;
        font-size: 14px;
        color: #c0c4cc;
      }
      position: absolute;
      z-index: 1005;
      top: 0;
      left: 0;
      right: 0;
      height: 28px;
      line-height: 28px;
      border: 1px solid #e7e8ea;
      border-radius: 4px;
      cursor: pointer;
      padding: 0 11px;
      font-size: 12px;
      color: #5c5d5e;
      background: #ffffff;
    }
    .dialog {
      position: fixed;
      z-index: 1010;
      top: 0;
      left: 0;
      height: 196px;
      max-width: 200px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #e7e8ea;
      box-shadow: 0px 0px 10px 0px rgba(203, 203, 203, 0.5);
      .dialog-input-wrap {
        display: flex;
        padding: 0 11px;
        font-size: 12px;
        color: #5c5d5e;
        height: 28px;
        line-height: 28px;
        .dialog-input {
          padding: 0;
          border: 0;
        }
        .icon {
          margin: 0 3px;
        }
      }
      .selector-wrap {
        display: flex;
        .item {
          flex: 1;
          overflow-y: scroll;
          height: 166px;
          .num {
            line-height: 28px;
            // padding-left: 12px;
            text-align: center;
            font-size: 12px;
            color: #5c5d5e;
            cursor: pointer;
            &.active {
              background: #eef3f6;
            }
          }
          &::-webkit-scrollbar {
            width: 4px;
          }
          &::-webkit-scrollbar-track {
            width: 4px;
            background: none;
          }
          &::-webkit-scrollbar-thumb {
            width: 4px;
            background: #d8d8d8;
          }
          &::-webkit-scrollbar-button {
          }
        }
      }
      &.top {
      }
    }
    &:hover {
      .ico {
        display: inline-block;
      }
    }
  }
  .deliver {
    margin: 0 7px;
  }
  .dialog-shadow {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
  }
}
.el-icon-error {
  opacity: 0.5;
}
.suer {
  border-top: 1px solid #e7e8ea;
  background-color: #fff;
  padding: 4px;
  text-align: right;
  box-shadow: 0px 5px 10px 0px rgba(203, 203, 203, 0.5);
  :nth-child(1) {
    color: #5c5d5e;
    cursor: pointer;
    margin-right: 30px !important;
  }
  :nth-child(2) {
    color: #07d1aa !important;
    cursor: pointer;
    margin-right: 2px !important;
  }
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
}
</style>
